import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { ReactComponent as TurnIconSvg } from "../../assets/3d-viewer/turn-icon.svg";
import { FONTS } from "../../styles/fonts";
import React from "react";
import { CloseButtonSvg } from "../../assets";
import { ThreeDModelState } from "./shared";
import { ThreeDModelComponentType } from "@swo/storefront";
import { Link } from "@swo/shared";
import { SwarovskiButton } from "../_shared-components/ui-elements/SwarovskiButton";
import { CSS_MQ } from "../../styles/breakpoints";

export const ModelInteractionHint: ReactTFC<{
  modelState: ThreeDModelState;
  buttonOnClick: () => void;
  onExitRequested: () => void;
  translations: ThreeDModelComponentType["translations"];
  link: Link | undefined;
}> = props => {
  const { modelState } = props;

  const LinkEl = props.link ? (
    <SwarovskiButton
      variant={"outline-inherit"}
      as={"a"}
      isInternal={props.link.type === "Internal Link"}
      link={props.link.data}
      scrollToTop={true}
      target={props.link.openInNewTab ? "_blank" : undefined}
      size={"small"}
      className={"_button"}
    >
      {props.link.label}
    </SwarovskiButton>
  ) : null;

  const Component =
    modelState === "idle" ? (
      <>
        <button onClick={props.buttonOnClick} css={buttonStyles} type={"button"}>
          <TurnIconSvg css={turnSvgStyles} />
          <span css={textStyles}>{props.translations.clickToInteract}</span>
        </button>
        {LinkEl}
      </>
    ) : modelState === "interacted-with" ? (
      <>
        <button onClick={props.onExitRequested} css={buttonStyles} type={"button"}>
          <CloseButtonSvg css={turnSvgStyles} />
          <span css={textStyles}>{props.translations.exit}</span>
        </button>
        {LinkEl}
      </>
    ) : null;

  return Component ? <div css={wrapperStyles}>{Component}</div> : null;
};

const wrapperStyles = css`
  position: absolute;
  bottom: 10px;
  z-index: 3;

  display: flex;
  align-items: center;

  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  padding: 4px 20px;
  ${CSS_MQ.atLeastMd} {
    justify-content: center;
    flex-direction: column;
    padding-bottom: 12px;
  }

  gap: 20px;

  color: var(--text-color);
`;

const buttonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;

  color: inherit;
`;

const turnSvgStyles = css`
  width: 32px;
  height: 32px;

  margin-right: 10px;

  color: inherit;
`;

const textStyles = css`
  ${FONTS.SwarovskiFutura300};

  font-size: 16px;
  letter-spacing: 0.78px;
  text-align: center;
  color: inherit;
`;
